import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Shield, PlusCircle, Edit, Trash2, Phone, Mail, MapPin, Save, X } from 'lucide-react';

const Apoderados = () => {
  const navigate = useNavigate();
  const [apoderados, setApoderados] = useState([]);
  const [cargando, setCargando] = useState(false);
  
  // Estado del formulario
  const [formData, setFormData] = useState({
    documentoIdentidad: '', nombres: '', apellidos: '',
    celular: '', correo: '', direccion: ''
  });
  const [editandoId, setEditandoId] = useState(null);

  useEffect(() => {
    cargarApoderados();
  }, []);

  const cargarApoderados = async () => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Apoderados`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) setApoderados(await res.json());
    } catch (e) { console.error("Error al cargar apoderados", e); }
  };

const handleGuardar = async (e) => {
    e.preventDefault();
    setCargando(true);
    const token = localStorage.getItem('token');
    
    const url = editandoId ? `${process.env.REACT_APP_API_URL}/Apoderados/${editandoId}` : `${process.env.REACT_APP_API_URL}/Apoderados`;
    const method = editandoId ? 'PUT' : 'POST';
    
    const payload = { ...formData, id: editandoId || 0, activo: true };

    try {
      const res = await fetch(url, {
        method, headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (res.ok || res.status === 204) {
        alert(editandoId ? 'Apoderado actualizado' : 'Apoderado registrado con éxito');
        setFormData({ documentoIdentidad: '', nombres: '', apellidos: '', celular: '', correo: '', direccion: '' });
        setEditandoId(null);
        cargarApoderados();
      } else {
        // RADAR DE ERRORES ACTIVADO:
        const errorText = await res.text();
        alert(`FALLO EN C# (Error ${res.status}): \n${errorText}`);
        console.error("Detalle del error:", errorText);
      }
    } catch (e) { 
      alert("Error de conexión con el servidor.");
      console.error(e); 
    } finally { 
      setCargando(false); 
    }
  };

  const handleEditar = (apoderado) => {
    setEditandoId(apoderado.id);
    setFormData({
      documentoIdentidad: apoderado.documentoIdentidad, nombres: apoderado.nombres,
      apellidos: apoderado.apellidos, celular: apoderado.celular || '',
      correo: apoderado.correo || '', direccion: apoderado.direccion || ''
    });
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar este apoderado?")) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Apoderados/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok || res.status === 204) {
        cargarApoderados();
      }
    } catch (e) { console.error("Error al eliminar", e); }
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setFormData({ documentoIdentidad: '', nombres: '', apellidos: '', celular: '', correo: '', direccion: '' });
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <Sidebar />
      <main className="flex-1 p-6 overflow-y-auto">
        <header className="mb-6">
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <Shield className="text-blue-600" /> Gestión de Apoderados
          </h1>
          <p className="text-slate-500 mt-1">Registra a los padres de familia para la facturación y envío de comunicados.</p>
        </header>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          {/* PANEL IZQUIERDO: FORMULARIO */}
          <div className="xl:col-span-1 bg-white p-6 rounded-xl shadow-sm border border-slate-200 h-fit">
            <h2 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2 border-b pb-2">
              {editandoId ? <Edit size={20} className="text-amber-500"/> : <PlusCircle size={20} className="text-green-500"/>}
              {editandoId ? 'Editar Apoderado' : 'Nuevo Apoderado'}
            </h2>
            
            <form onSubmit={handleGuardar} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">DNI / CE *</label>
                <input type="text" required value={formData.documentoIdentidad} onChange={e => setFormData({...formData, documentoIdentidad: e.target.value})} className="w-full p-2.5 border rounded-lg outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50" placeholder="Número de documento" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-slate-500 mb-1">Nombres *</label>
                  <input type="text" required value={formData.nombres} onChange={e => setFormData({...formData, nombres: e.target.value})} className="w-full p-2.5 border rounded-lg outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 mb-1">Apellidos *</label>
                  <input type="text" required value={formData.apellidos} onChange={e => setFormData({...formData, apellidos: e.target.value})} className="w-full p-2.5 border rounded-lg outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50" />
                </div>
              </div>
              
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Celular (Para SMS/WhatsApp)</label>
                <div className="flex items-center border rounded-lg bg-slate-50 focus-within:ring-2 focus-within:ring-blue-500 overflow-hidden">
                  <div className="pl-3 text-slate-400"><Phone size={16} /></div>
                  <input type="text" value={formData.celular} onChange={e => setFormData({...formData, celular: e.target.value})} className="w-full p-2.5 outline-none bg-transparent" placeholder="Ej: 987654321" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Correo (Para Boletas y Accesos)</label>
                <div className="flex items-center border rounded-lg bg-slate-50 focus-within:ring-2 focus-within:ring-blue-500 overflow-hidden">
                  <div className="pl-3 text-slate-400"><Mail size={16} /></div>
                  <input type="email" value={formData.correo} onChange={e => setFormData({...formData, correo: e.target.value})} className="w-full p-2.5 outline-none bg-transparent" placeholder="ejemplo@correo.com" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Dirección de Facturación</label>
                <div className="flex items-start border rounded-lg bg-slate-50 focus-within:ring-2 focus-within:ring-blue-500 overflow-hidden pt-2">
                  <div className="pl-3 text-slate-400 mt-1"><MapPin size={16} /></div>
                  <textarea value={formData.direccion} onChange={e => setFormData({...formData, direccion: e.target.value})} rows="2" className="w-full p-2 outline-none bg-transparent resize-none" placeholder="Dirección completa"></textarea>
                </div>
              </div>

              <div className="pt-2 flex gap-2">
                <button type="submit" disabled={cargando} className="flex-1 bg-blue-600 text-white p-2.5 rounded-lg font-bold hover:bg-blue-700 flex justify-center items-center gap-2 transition-colors">
                  <Save size={18}/> {editandoId ? 'Actualizar' : 'Guardar'}
                </button>
                {editandoId && (
                  <button type="button" onClick={cancelarEdicion} className="px-4 bg-slate-200 text-slate-700 rounded-lg font-bold hover:bg-slate-300 transition-colors">
                    <X size={18}/>
                  </button>
                )}
              </div>
            </form>
          </div>

          {/* PANEL DERECHO: LISTA DE APODERADOS */}
          <div className="xl:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-fit">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse whitespace-nowrap">
                <thead className="bg-slate-50 border-b">
                  <tr className="text-xs text-slate-500 uppercase tracking-wide">
                    <th className="p-4 font-bold">Documento</th>
                    <th className="p-4 font-bold">Apoderado</th>
                    <th className="p-4 font-bold">Contacto</th>
                    <th className="p-4 font-bold text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {apoderados.map(apo => (
                    <tr key={apo.id} className="border-b hover:bg-slate-50 transition-colors">
                      <td className="p-4 font-medium text-slate-600">{apo.documentoIdentidad}</td>
                      <td className="p-4 font-bold text-slate-800">{apo.apellidos}, {apo.nombres}</td>
                      <td className="p-4">
                        <div className="flex flex-col gap-1 text-slate-600 text-xs">
                          {apo.celular && <span className="flex items-center gap-1"><Phone size={12} className="text-slate-400"/> {apo.celular}</span>}
                          {apo.correo && <span className="flex items-center gap-1"><Mail size={12} className="text-slate-400"/> {apo.correo}</span>}
                          {!apo.celular && !apo.correo && <span className="text-slate-400 italic">Sin datos de contacto</span>}
                        </div>
                      </td>
                      <td className="p-4 flex justify-center gap-2">
                        <button onClick={() => handleEditar(apo)} className="p-2 text-blue-600 bg-blue-50 rounded hover:bg-blue-100 transition-colors" title="Editar"><Edit size={16}/></button>
                        <button onClick={() => handleEliminar(apo.id)} className="p-2 text-red-600 bg-red-50 rounded hover:bg-red-100 transition-colors" title="Eliminar"><Trash2 size={16}/></button>
                      </td>
                    </tr>
                  ))}
                  {apoderados.length === 0 && (
                    <tr><td colSpan="4" className="p-8 text-center text-slate-400">No hay apoderados registrados.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default Apoderados;